import { useCallback, useEffect, useId, useRef, useState } from "react";
import {
  Container,
  MobileSupportContainer,
  SearchBarSection,
  SearchBarSectionSubcontainer,
  SummarySection,
} from "./styles";
import SearchBar from "../../components/ui-v2/Inputs/Search";
import TabsGroup from "../../components/ui/groups/TabsGroup";
import { useTypedSelector } from "../../hooks/useTypedSelector";
import DropdownFilter from "../../components/ui-v2/DropdownFilter";
import {
  TCellNotTagMiscellaneous,
  TCellStyleVariants,
  TTableBody,
  TText,
} from "../../components/ui-v2/TableGrid";
import { breakStringPreserveSpaces, cnpjMask } from "../../utils/formatters";

import {
  TInvoice,
  TInvoiceEntryStatus,
  TInvoiceManifestastionStatus,
  TInvoiceSituation,
  TNexaasProduct,
  TPaymentSlip,
  setAttachedPaymentSlips,
  setIsLoadingInvoices,
  setIsRestoringQuerystring,
  setToastActionId,
  setToastState,
} from "../../redux/reducers/globalState";
import { useTypedDispatch } from "../../hooks/useTypedDispatch";
import {
  attachPaymentSlipToInvoice,
  createExpressGoodsStockEntry,
  deleteNFEQueue,
  detachPaymentSlipFromInvoice,
  fetchInvoice,
  fetchInvoices,
  getQueueNFE,
  importInvoiceFiles,
  linkInvoiceToPayable,
  onSubmitAccessKeys,
  renamePaymentSlipLabel,
} from "../../redux/actions";
import { useNavigationManager } from "../../hooks/useNavigationManager";
import {
  CALENDAR_CONTENT_OPTIONS,
  TCalendarMenuOptions,
} from "../../components/ui-v2/DropdownFilter/Menu";
import { sub } from "date-fns/sub";
import { format } from "date-fns/format";
import { parse } from "date-fns/parse";
import {
  backendErrorMessageHandler,
  getQuerystringParams,
  handleParseToDateCalendarOptions,
  handleRevertTranslateCalendarOptions,
  handleSetDataToLocalStorage,
  handleSetEndDate,
  handleTranslateCalendarOptions,
  TQuerystringParams,
} from "../../utils/miscellaneous";
import { localStorageConstants } from "../../utils/constants";
import Modal from "../../components/ui-v2/Modal";
import TableGrid from "../../components/ui-v2/TableGrid";
import apiService from "../../services/api";
import { TPayableAccount } from "../../components/ui-v2/Modal/Forms/LinkPayable";
import { ROUTES } from "../../router";
import {
  UilAngleDown,
  UilCopyAlt,
  UilExternalLinkAlt,
  UilLink,
  UilSearch,
  UilUpload,
} from "@iconscout/react-unicons";
import AttachmentMenu from "../../components/ui-v2/Menus/AttachmentMenu";
import Tooltip from "../../components/ui-v2/Tooltip";
import axios, { CancelTokenSource } from "axios";
import Button from "../../components/ui-v2/Button";
import ImportFileMenu from "../../components/ui-v2/Menus/ImportFileMenu";
import { TQueueNFEItem } from "../../redux/reducers/accessKeyImport";
import { useProportionalGridTemplateColumns } from "../../hooks/useProportionalGridTemplateColumns";
import { parseISO } from "date-fns/parseISO";
import Tag from "../../components/ui-v2/Tag";

function Home() {
  const dispatch = useTypedDispatch();
  const { goTo, setQuerystring } = useNavigationManager();

  const cancelTokenRef = useRef<CancelTokenSource>(axios.CancelToken.source());

  const fetchInvoicesCancelTokenRef = useRef<CancelTokenSource>(
    axios.CancelToken.source()
  );

  const debounceRef = useRef<NodeJS.Timeout | null>(null);

  const { invoiceState, attachedPaymentSlips, toastActionId, updatedInvoice } =
    useTypedSelector((state) => state.globalState.data);

  const isLoading = useTypedSelector(
    (state) => state.globalState.isLoadingInvoices
  );

  const isRestoringQuerystring = useTypedSelector(
    (state) => state.globalState.isRestoringQuerystring
  );

  const sidebarState = useTypedSelector((state) => state.sidebar);

  const reduxQuerystring = useTypedSelector((state) => state.querystring);

  const selectedOrganization = useTypedSelector(
    (state) => state.organizations.selectedOrganization
  );

  const {
    accessKeys,
    queueNFE,
    loading: isLoadingQueueNFE,
  } = useTypedSelector((state) => state.accessKeyImport);

  const prevQueueCorrelationRef = useRef<number | null>(null);
  const pollingIntervalRef = useRef<NodeJS.Timeout | null>(null);

  const filesInputRef = useRef<HTMLInputElement | null>(null);

  const startDateRef = useRef<string | undefined>(
    format(sub(new Date(), { days: 30 }), "yyyy-MM-dd")
  );
  const endDateRef = useRef<string | undefined>(
    format(new Date(), "yyyy-MM-dd")
  );

  const [launchStatus, setLaunchStatus] = useState<
    TInvoiceEntryStatus | undefined
  >(
    getQuerystringParams().launch_status === 40
      ? undefined
      : (getQuerystringParams().launch_status as TInvoiceEntryStatus)
  );
  const entryStatusRef = useRef<TInvoiceEntryStatus | undefined>(
    getQuerystringParams().launch_status === 40
      ? undefined
      : (getQuerystringParams().launch_status as TInvoiceEntryStatus)
  );

  const payablesRef = useRef<boolean | undefined>();
  const goodsEntryRef = useRef<boolean | undefined>();
  const pageRef = useRef(1);
  const itemsPerPageRef = useRef(100);
  const searchRef = useRef<string | undefined>();

  const importFileButtonRef = useRef<HTMLButtonElement | null>(null);

  const clearSelectedPaymentSlipsRef = useRef<(() => void) | null>(null);

  const entryStatusFilterRef = useRef<string[]>([]);
  // Ref to hold setSelected for use in onCancel
  const entryStatusSetSelectedRef = useRef<React.Dispatch<
    React.SetStateAction<string[]>
  > | null>(null);

  const selectPayableRef = useRef<TPayableAccount>();

  const payableModalInvoiceRef = useRef<TInvoice | undefined>();
  const allInvoicesRef = useRef<TInvoice[]>([]);

  const goodsStockCheckDataRef = useRef<{
    success: TNexaasProduct[];
    error: TNexaasProduct[];
  } | null>(null);

  // Store refs for each row's button
  const buttonRefs = useRef<{ [key: string]: HTMLButtonElement | null }>({});
  // Store which menu is open
  const [openMenuRow, setOpenMenuRow] = useState<string | null>(null);

  const searchBarContainerId = useId();

  const [entryStatusSearch /* setEntryStatusSearch */] = useState("");

  const [invoiceToAttachLinks, setInvoiceToAttachLinks] =
    useState<TInvoice | null>(null);

  const [paymentSlipToBreakLink, setPaymentSlipToBreakLink] = useState<
    { target: TPaymentSlip; origin: TInvoice } | undefined
  >();

  const [shouldShowImportFileMenu, setShouldShowImportFileMenu] =
    useState(false);

  const [paymentSlipToRename, setPaymentSlipToRename] = useState<
    TPaymentSlip | undefined
  >();

  const [shouldShowAttachmentMenu, setShouldShowAttachmentMenu] = useState("");

  const [shouldOpenImportFileModal, setShouldOpenImportFileModal] =
    useState(false);

  const [shouldOpenRequestedPayableModal, setShouldOpenRequestedPayableModal] =
    useState(false);

  const [
    shouldOpenCancelPayableRequestModal,
    setShouldOpenCancelPayableRequestModal,
  ] = useState(false);

  const [shouldOpenPayable, setShouldOpenPayable] = useState(false);

  const [shouldOpenPayableModal, setShouldOpenPayableModal] = useState(false);
  const [shouldOpenLinkPayableModal, setShouldOpenLinkPayableModal] =
    useState(false);
  const [isLinkPayableLoading, setIsLinkPayableLoading] = useState(false);
  const [shouldUpdateComponent, _setShouldUpdateComponent] = useState(false);

  const [shouldOpenLinkPaymentSlipModal, setShouldOpenLinkPaymentSlipModal] =
    useState(false);

  const [
    shouldOpenInstallmentAccountModal,
    setShouldOpenInstallmentAccountModal,
  ] = useState(false);

  const [shouldRejectFilledEntryStatus /* setShouldRejectFilledEntryStatus */] =
    useState(false);

  const [shouldOpenGoodsModal, setShouldOpenGoodsModal] = useState(false);

  const [shouldOpenGoodsAutomatedModal, setShouldOpenGoodsAutomatedModal] =
    useState(false);

  const [shouldOpenGoodsStockCheckModal, setShouldOpenGoodsStockCheckModal] =
    useState(false);

  const [shouldOpenGoodsCompletedModal, setShouldOpenGoodsCompletedModal] =
    useState(false);

  const selectedNFEQueueItemRef = useRef<TQueueNFEItem>({
    access_key: "",
    cnpj: "",
    created_at: "",
    has_error: false,
    reason: "",
    updated_at: "",
    uuid: "",
  });

  const entryStatusOptions = [
    "Sem lançamentos",
    "Contas a pagar lançada",
    "Entrada de mercadorias lançada",
  ];

  // Filter options based on search
  const filteredEntryStatusOptions = entryStatusOptions.filter((option) =>
    option.toLowerCase().includes(entryStatusSearch.toLowerCase())
  );

  const SHOULD_DISABLE_FINTERA_ACTIONS =
    selectedOrganization && !selectedOrganization.permissions?.fintera;

  const SHOULD_DISABLE_NEXAAS_ACTIONS =
    selectedOrganization && !selectedOrganization.permissions?.nexaas_omni;

  const originalWidths = [22, 77, 160, 257, 376, 260, 300, 356, 300, 300, 0];
  const sidebarOffset = sidebarState.isFixed /* && sidebarState.isOpen */
    ? 240
    : 48;

  const gridTemplateColumns =
    useProportionalGridTemplateColumns(originalWidths);

  const handleFormatStatusCell = (
    status: TInvoiceManifestastionStatus | null
  ) => {
    switch (status) {
      case 10:
        return { style: "blue", value: "Ciente", icon: "noIcon" };
      case 20:
        return { style: "green", value: "Confirmada", icon: "noIcon" };
      case 30:
        return { style: "gray", value: "Desconhecida", icon: "noIcon" };
      case 40:
        return { style: "red", value: "Recusada", icon: "noIcon" };
      case null:
        return { style: "default", value: " - " };
    }
  };

  const getInvoiceSituationLabel = (situation: TInvoiceSituation): string => {
    switch (situation) {
      case 1:
        return "Uso autorizado";
      case 2:
        return "Uso denegado";
      case 3:
        return "NF-e Cancelada";
      default:
        return "Uso autorizado";
    }
  };

  const handleFormatSituationCell = (situation: TInvoiceSituation) => {
    const situationLabel = getInvoiceSituationLabel(situation);
    
    const styleVariant = 
      situation === 1
        ? "green"
        : situation === 2
        ? "red"
        : "darkGray";
    
    return {
      style: styleVariant,
      value: situationLabel,
      icon: "noIcon"
    };
  };

  const rowFormatter = (invoice: TInvoice, index: number) => {
    return [
      { style: "default", value: invoice?.number ? invoice.number : "-" },
      {
        style: "default",
        value: invoice.date_issue
          ? format(parseISO(invoice?.date_issue), "dd/MM/yyyy 'às' HH:mm")
          : "-",
      },
      {
        style: "miscellaneous",
        tooltip: invoice.issuer.name && {
          text: (() => {
            const values = breakStringPreserveSpaces(invoice.issuer.name, 24);

            return values.map((value, index) => ({
              style: "default",
              text: value,
              shouldBreakLine: index !== values.length - 1,
            }));
          })(),
          customTopPosition: invoice.issuer.name
            ? index * 97 +
              (215 -
                (breakStringPreserveSpaces(invoice.issuer.name, 24).length -
                  1) *
                  20)
            : "",
          hasScrollableRef: true,
        },
        values: [
          {
            style: "bold",
            text: invoice.issuer.name
              ? invoice?.issuer.name.length > 20
                ? invoice.issuer.name.slice(0, 20) + "..."
                : invoice.issuer.name
              : "-",
            shouldBreakLine: true,
          },
          {
            style: "default",
            text: invoice.issuer.document_number
              ? cnpjMask(invoice?.issuer.document_number)
              : "-",
            shouldBreakLine: false,
          },
        ],
      },
      {
        style: "default",
        value: invoice.amount ? "R$ " + invoice?.amount.replace(".", ",") : "-",
      },
      handleFormatStatusCell(invoice?.manifestation),
      handleFormatSituationCell(invoice?.situation),
      [
        {
          style: "button",
          icon: "nfe",
          isDisabled: invoice.file_nfe === null,
          onClick() {
            window.open(invoice.file_nfe ? invoice.file_nfe : "", "_blank");
          },
          tooltip: {
            text: [
              invoice.file_nfe !== null
                ? {
                    style: "default",
                    text: "Visualizar DANFE",
                    shouldBreakLine: false,
                  }
                : {
                    style: "default",
                    text: "DANFE indisponível",
                    shouldBreakLine: false,
                  },
            ],
            customTopPosition: index * 97 + 223,
            hasScrollableRef: true,
          },
        },
        {
          style: "button",
          icon: "xml",
          isDisabled: invoice.file_xml === null,
          onClick() {
            window.open(invoice.file_xml ? invoice.file_xml : "", "_blank");
          },
          tooltip: {
            text: [
              invoice.file_xml !== null
                ? {
                    style: "default",
                    text: "Visualizar XML",
                    shouldBreakLine: false,
                  }
                : {
                    style: "default",
                    text: "XML indisponível",
                    shouldBreakLine: false,
                  },
            ],
            customTopPosition: index * 97 + 223,
            hasScrollableRef: true,
          },
        },
      ],
      [
        {
          style: "button",
          icon:
            invoice.goods_receipt_url === null
              ? "goodsReceiptYellow"
              : invoice.nexaas_state === 10
              ? "goodsReceiptYellow"
              : invoice.nexaas_state === 30
              ? "goodsExpressBlue"
              : invoice.nexaas_state === 40
              ? "goodsExpressRed"
              : invoice.nexaas_state === 50
              ? "goodsExpressBlueAndClock"
              : [20, 60].includes(invoice.nexaas_state) && "goodsExpressGreen",
          isDisabled:
            (invoice.goods_receipt_url !== null &&
              invoice.goods_receipt_url.length === 0) ||
            invoice.invoice_type === 20 ||
            invoice.file_xml === null ||
            SHOULD_DISABLE_NEXAAS_ACTIONS,
          tooltip:
            !SHOULD_DISABLE_NEXAAS_ACTIONS &&
            invoice.invoice_type !== 20 &&
            invoice.goods_receipt_url === null &&
            invoice.file_xml !== null
              ? {
                  text: [
                    {
                      style: "default",
                      text: "Criar uma entrada de mercadoria",
                      shouldBreakLine: false,
                    },
                  ],
                  customTopPosition: 97 * index + 208.5,
                  hasScrollableRef: true,
                }
              : SHOULD_DISABLE_NEXAAS_ACTIONS ||
                invoice.invoice_type === 20 ||
                invoice.file_xml === null ||
                (invoice.goods_receipt_url as string).length === 0
              ? {
                  text: [
                    {
                      style: "default",
                      text: "NF não possui produtos para dar entrada",
                      shouldBreakLine: false,
                    },
                  ],
                  customTopPosition: index * 97 + 223,
                  hasScrollableRef: true,
                }
              : {
                  text: [
                    {
                      style: "default",
                      text:
                        invoice.nexaas_state === 30
                          ? "Entrada criada"
                          : invoice.nexaas_state === 40
                          ? "Entrada criada"
                          : invoice.nexaas_state === 50
                          ? "Lançando estoques"
                          : [20, 60].includes(invoice.nexaas_state) &&
                            "Entrada finalizada",
                      shouldBreakLine: true,
                    },
                    invoice.nexaas_state === 30 && {
                      style: "default",
                      text: "Clique para visualizar",
                      shouldBreakLine: false,
                    },
                    [20, 60].includes(invoice.nexaas_state) && {
                      style: "default",
                      text: "Clique para visualizar",
                      shouldBreakLine: false,
                    },
                    [40, 50].includes(invoice.nexaas_state) && {
                      style: "default",
                      text:
                        invoice.nexaas_state === 40
                          ? "Corrija os erros para finalizar"
                          : invoice.nexaas_state === 50 &&
                            "Pode levar alguns minutos",
                      shouldBreakLine: false,
                    },
                  ] as TText[],
                  customTopPosition:
                    97 * index + (invoice.nexaas_state > 30 ? 208.5 : 223),
                  hasScrollableRef: true,
                },
          onClick() {
            payableModalInvoiceRef.current = invoice;
            if (invoice.goods_receipt_url === null) {
              if (invoice.nexaas_state === 10) {
                setShouldOpenGoodsModal(true);
              }
            } else if (invoice.goods_receipt_url) {
              setShouldOpenGoodsAutomatedModal(true);
            }
          },
        },
        {
          style: "button",
          icon:
            invoice.accounts_payable_url === null
              ? "payableYellow"
              : invoice.accounts_payable_url.length > 0
              ? "payableGreen"
              : "payableYellow",
          isDisabled:
            (invoice.accounts_payable_url !== null &&
              invoice.accounts_payable_url.length === 0) ||
            invoice.file_xml === null ||
            SHOULD_DISABLE_FINTERA_ACTIONS,
          tooltip:
            !SHOULD_DISABLE_FINTERA_ACTIONS &&
            invoice.accounts_payable_url === null &&
            invoice.file_xml !== null
              ? {
                  text: [
                    {
                      style: "default",
                      text: "Criar uma ",
                      shouldBreakLine: false,
                    },
                    {
                      style: "bold",
                      text: "conta a pagar",
                      shouldBreakLine: false,
                    },
                  ],
                  customTopPosition: 97 * index + 208.5,
                  hasScrollableRef: true,
                }
              : SHOULD_DISABLE_FINTERA_ACTIONS ||
                invoice.file_xml === null ||
                (invoice.accounts_payable_url as string).length === 0
              ? {
                  text: [
                    {
                      style: "default",
                      text: "Contas a pagar indisponível",
                      shouldBreakLine: false,
                    },
                  ],
                  customTopPosition: index * 97 + 223,
                  hasScrollableRef: true,
                }
              : {
                  text: [
                    {
                      style: "default",
                      text: "Conta a pagar criada",
                      shouldBreakLine: true,
                    },
                    {
                      style: "default",
                      text: "Clique para acessar na",
                      shouldBreakLine: false,
                    },
                    {
                      style: "bold",
                      text: " Fintera",
                      shouldBreakLine: false,
                    },
                  ],
                  customTopPosition: 97 * index + 208.5,
                  hasScrollableRef: true,
                },

          onClick() {
            if (invoice.accounts_payable_url === null) {
              payableModalInvoiceRef.current = invoice;
              setShouldOpenPayable(true);
            } else {
              window.open(
                invoice.accounts_payable_url
                  ? invoice.accounts_payable_url
                  : "",
                "_blank"
              );
            }
          },
        },
      ],
      {
        style: "button",
        icon: "ellipsisV",
        hasScrollableRef: true,
        isDisabled:
          invoice.manifestation !== null &&
          ![10, 20].includes(invoice.launch_status) &&
          invoice.goods_receipt_url !== null &&
          invoice.accounts_payable_url !== null,
        content: [
          invoice.invoice_type !== 20 && "editStatus",
          invoice.launch_status === 10 && "markAsFinished",
          invoice.launch_status === 20 && "markAsPending",
        ],
        onClick(select: string) {
          if (select === "openGoodsModal") {
            payableModalInvoiceRef.current = invoice;
            setShouldOpenGoodsModal(true);
          }

          if (select === "openPayableModal") {
            payableModalInvoiceRef.current = invoice;
            setShouldOpenPayable(true);
          }

          if (select === "importFile") {
            if (filesInputRef.current) filesInputRef.current.click();
          }

          if (select === "linkPaymentSlip") {
            setShouldOpenLinkPaymentSlipModal(true);
          }

          handleSetDataToLocalStorage(
            localStorageConstants.SELECT_INVOICE,
            invoice
          );
          handleSetDataToLocalStorage(
            localStorageConstants.CURRENT_ENTRY_STATUS,
            entryStatusRef.current === undefined ? 40 : entryStatusRef.current
          );
        },
      },
    ] as TTableBody<TCellStyleVariants>[];
  };

  const handleSecondRowLeftSideCustomNodeRender = (
    invoice: TInvoice,
    _index: number
  ) => {
    return (
      <span>
        <Tooltip
          text={[{ text: "Copiar", style: "default", shouldBreakLine: false }]}
        >
          <button
            role="button"
            onClick={() => {
              navigator.clipboard.writeText(invoice.access_key).then(() => {
                dispatch(
                  setToastState({
                    variant: "success",
                    message: {
                      title: "Sucesso",
                      description: "Chave de acesso copiada",
                    },
                    shouldShow: true,
                  })
                );
              });
            }}
          >
            <UilCopyAlt />
          </button>
        </Tooltip>
      </span>
    );
  };

  const handleSecondRowRightSideCustomNodeRender = (
    invoice: TInvoice,
    rowIndex: number
  ) => {
    return invoice.boletos_exists ? (
      <span style={{ position: "relative", display: "inline-block" }}>
        <button
          ref={(el) => (buttonRefs.current[rowIndex] = el)}
          role="button"
          data-testid="link-container"
          onClick={() => {
            if (attachedPaymentSlips.length > 0) {
              dispatch(setAttachedPaymentSlips([]));
              setShouldShowAttachmentMenu("");
              setOpenMenuRow(null);
            } else {
              apiService
                .getInvoiceAttachedPaymentSlips(
                  invoice.uuid,
                  cancelTokenRef.current.token
                )
                .then((response: any) => {
                  dispatch(setAttachedPaymentSlips(response.data));
                  setShouldShowAttachmentMenu(`${rowIndex}`);
                  setOpenMenuRow(`${rowIndex}`);
                });
            }
          }}
        >
          Ver boletos <UilAngleDown />
        </button>

        {shouldShowAttachmentMenu === `${rowIndex}` &&
          attachedPaymentSlips.length > 0 &&
          openMenuRow === `${rowIndex}` && (
            <div
              style={{
                position: "absolute",
                top: buttonRefs.current[rowIndex]?.offsetHeight || 40,
                right: 0,
                zIndex: 1000,
                minWidth: 240,
                // Add your menu styling here (background, shadow, etc)
              }}
            >
              <AttachmentMenu
                shouldShowMenu
                onClickAway={() => {
                  dispatch(setAttachedPaymentSlips([]));
                  setShouldShowAttachmentMenu("");
                  setOpenMenuRow(null);
                }}
                items={attachedPaymentSlips.map((paymentSlip: TPaymentSlip) => {
                  return {
                    onRename() {
                      setPaymentSlipToRename(paymentSlip);
                    },
                    onDelete:
                      paymentSlip.fintera_id &&
                      paymentSlip.fintera_id.length > 0
                        ? undefined
                        : () => {
                            setPaymentSlipToBreakLink({
                              target: paymentSlip,
                              origin: invoice,
                            });
                          },
                    name: paymentSlip.label,
                    searchParam: paymentSlip.bar_code,
                    url:
                      ROUTES.PAYMENT_SLIP +
                      window.location.search +
                      "&period=all",
                  };
                })}
                onAction={{
                  callback: () => {
                    setInvoiceToAttachLinks(invoice);
                    setShouldOpenLinkPaymentSlipModal(true);
                    dispatch(setAttachedPaymentSlips([]));
                    setShouldShowAttachmentMenu("");
                    setOpenMenuRow(null);
                  },
                  text: "Vincular boleto",
                }}
              />
            </div>
          )}
      </span>
    ) : (
      <span>
        <p>Nenhum boleto vinculado</p>
        <button
          data-testid="link-container"
          role="button"
          onClick={() => {
            setInvoiceToAttachLinks(invoice);
            setShouldOpenLinkPaymentSlipModal(true);
          }}
        >
          <UilLink />
          &nbsp;Vincular
        </button>
      </span>
    );
  };

  const secondRowFormatter = (invoice: TInvoice) => ({
    style: "miscellaneous",
    values: [
      {
        style: "default",
        text: "Chave de acesso: ",
        shouldBreakLine: false,
      },
      {
        style: "faded",
        text: invoice.access_key,
        shouldBreakLine: false,
      },
    ],
  });

  const handleCalendarOnClear = () => {
    const querystring = { ...reduxQuerystring };

    startDateRef.current = undefined;
    endDateRef.current = undefined;
    delete querystring.start_date;
    delete querystring.end_date;
    querystring.period = "all";

    setQuerystring(querystring);

    debouncedUpdateAllInvoicesRef();
  };

  const handleCalendarOnSelect = (selected: string[]) => {
    const select = selected as TCalendarMenuOptions[];
    const querystring = { ...reduxQuerystring };
    if (CALENDAR_CONTENT_OPTIONS.includes(select[0])) {
      const tempStartDate = handleParseToDateCalendarOptions(select[0]);

      if (tempStartDate === undefined) {
        startDateRef.current = undefined;
        endDateRef.current = undefined;
        delete querystring.start_date;
        delete querystring.end_date;
        querystring.period = "all";

        if (querystring.page) {
          querystring.page = 1;
        }

        if (querystring.modal) {
          delete querystring.modal;
        }

        setQuerystring(querystring);

        setTimeout(() => {
          debouncedUpdateAllInvoicesRef();
        }, 100);
      } else {
        const formatTempStartDate = format(tempStartDate, "yyyy-MM-dd");
        if (formatTempStartDate !== startDateRef.current) {
          const formatEndDate = handleSetEndDate(select[0]);
          startDateRef.current = formatTempStartDate;
          endDateRef.current = formatEndDate;
          querystring.period = handleTranslateCalendarOptions(
            select[0] as TCalendarMenuOptions
          ) as string;
          delete querystring.start_date;
          delete querystring.end_date;

          if (querystring.page) {
            querystring.page = 1;
          }

          if (querystring.modal) {
            delete querystring.modal;
          }

          setQuerystring(querystring);

          setTimeout(() => {
            debouncedUpdateAllInvoicesRef(undefined, formatEndDate);
          }, 100);
        }
      }
    } else {
      const dates = select[0].split(" - ");
      const parsedStart =
        dates[0] && typeof dates[0] === "string"
          ? parse(dates[0], "dd/MM/yyyy", new Date())
          : undefined;
      const tempStartDate =
        parsedStart && !isNaN(parsedStart.getTime())
          ? format(parsedStart, "yyyy-MM-dd")
          : "";

      const parsedEnd =
        dates[1] && typeof dates[1] === "string"
          ? parse(dates[1], "dd/MM/yyyy", new Date())
          : undefined;
      const tempEndDate =
        parsedEnd && !isNaN(parsedEnd.getTime())
          ? format(parsedEnd, "yyyy-MM-dd")
          : "";

      if (tempStartDate !== startDateRef.current)
        startDateRef.current = tempStartDate;
      if (tempEndDate !== endDateRef.current) endDateRef.current = tempEndDate;
      querystring.end_date = tempEndDate;
      querystring.start_date = tempStartDate;
      querystring.period = undefined;

      if (querystring.page) {
        querystring.page = 1;
      }

      if (querystring.modal) {
        delete querystring.modal;
      }

      setQuerystring(querystring);

      setTimeout(() => {
        debouncedUpdateAllInvoicesRef();
      }, 100);
    }
  };

  const handlePeriodForceSelectOptions = () => {
    const queryStrings = { ...reduxQuerystring };

    const calendarOptions = [
      ...CALENDAR_CONTENT_OPTIONS.map((string) => string.toLowerCase()),
    ];

    if (
      queryStrings.period &&
      calendarOptions.includes(
        handleRevertTranslateCalendarOptions(
          queryStrings.period as TCalendarMenuOptions
        ) as string
      )
    ) {
      return [
        calendarOptions.indexOf(
          handleRevertTranslateCalendarOptions(
            queryStrings.period as TCalendarMenuOptions
          ) as string
        ),
      ];
    } else if (queryStrings.start_date && queryStrings.end_date) {
      startDateRef.current = queryStrings.start_date;
      endDateRef.current = queryStrings.end_date;

      return [
        queryStrings.start_date.replace(/(\d{4})-(\d{2})-(\d{2})/, "$3/$2/$1"),
        queryStrings.end_date.replace(/(\d{4})-(\d{2})-(\d{2})/, "$3/$2/$1"),
      ];
    }

    return undefined;
  };

  const handleEntryStatusOnClear = () => {
    const queryStrings = { ...reduxQuerystring };

    payablesRef.current = undefined;
    goodsEntryRef.current = undefined;

    delete queryStrings.has_payable_accounts;
    delete queryStrings.has_goods_receipt;

    if (entryStatusRef.current) {
      queryStrings.launch_status = entryStatusRef.current ?? 40;
    }

    if (queryStrings.page) {
      queryStrings.page = 1;
    }

    if (queryStrings.modal) {
      delete queryStrings.modal;
    }

    setQuerystring(queryStrings);

    debouncedUpdateAllInvoicesRef();
  };

  const handleEntryStatusOnAction = (
    selectDataRef: React.MutableRefObject<string[]>
  ) => {
    let hasPayable, hasGoods;
    selectDataRef.current = entryStatusFilterRef.current;

    const queryStrings = { ...reduxQuerystring };

    if (selectDataRef.current.length) {
      if (selectDataRef.current.includes("2")) {
        hasGoods = true;
      }
      if (selectDataRef.current.includes("1")) {
        hasPayable = true;
      }
      if (
        selectDataRef.current.includes("0") &&
        selectDataRef.current.length === 1
      ) {
        hasPayable = false;
        hasGoods = false;
      }
      payablesRef.current = hasPayable;
      goodsEntryRef.current = hasGoods;

      queryStrings.has_payable_accounts = payablesRef.current;

      queryStrings.has_goods_receipt = goodsEntryRef.current;

      if (entryStatusRef.current) {
        queryStrings.launch_status = entryStatusRef.current ?? 40;
      }

      if (queryStrings.page) {
        queryStrings.page = 1;
      }

      if (queryStrings.modal) {
        delete queryStrings.modal;
      }

      setQuerystring(queryStrings);
    } else {
      payablesRef.current = undefined;
      goodsEntryRef.current = undefined;

      delete queryStrings.has_payable_accounts;
      delete queryStrings.has_goods_receipt;

      if (entryStatusRef.current) {
        queryStrings.launch_status = entryStatusRef.current ?? 40;
      }

      if (queryStrings.page) {
        queryStrings.page = 1;
      }

      if (queryStrings.modal) {
        delete queryStrings.modal;
      }

      setQuerystring(queryStrings);
    }
    debouncedUpdateAllInvoicesRef();
  };

  const handleEntryStatusOnCancel = (
    selectDataRef: React.MutableRefObject<string[]>
  ) => {
    const reset = getDefaultEntryStatusOptions(reduxQuerystring) || [];
    entryStatusFilterRef.current = reset;
    selectDataRef.current = reset;
    // Use setSelected from ref if available
    setTimeout(() => {
      if (entryStatusSetSelectedRef.current) {
        entryStatusSetSelectedRef.current(reset);
      }
    }, 200);
  };

  // Handles user selection, updates refs and state (uses entryStatusFilterRef as source of truth)
  const handleEntryStatusCustomFilter = (
    index: string,
    _selected: string[],
    setSelected: React.Dispatch<React.SetStateAction<string[]>>,
    selectDataRef: React.MutableRefObject<string[]>,
    prevSelectDataRef: React.MutableRefObject<string[]>,
    setShouldUpdate: React.Dispatch<React.SetStateAction<boolean>>
  ) => {
    // Store setSelected for use in onCancel
    entryStatusSetSelectedRef.current = setSelected;

    let currentSelection = entryStatusFilterRef.current;
    prevSelectDataRef.current = [...currentSelection];

    let newSelection: string[] = [];
    if (currentSelection.includes(index)) {
      // Deselect: remove only the clicked index
      newSelection = currentSelection.filter((v) => v !== index);
    } else if (index === "0") {
      // Selecting '0' makes it exclusive
      newSelection = ["0"];
    } else {
      // Add index, but remove '0' if present
      newSelection = currentSelection.filter((v) => v !== "0");
      newSelection.push(index);
    }
    // Ensure only unique values and no empty strings
    newSelection = Array.from(new Set(newSelection)).filter((v) => v !== "");
    entryStatusFilterRef.current = newSelection;
    selectDataRef.current = newSelection;
    setSelected(newSelection);
    setShouldUpdate(true);
    setTimeout(() => setShouldUpdate(false), 20);
  };

  const getDefaultEntryStatusOptions = (queryStrings: TQuerystringParams) => {
    const hasPayableCondition = queryStrings.has_payable_accounts;
    const hasGoodsCondition = queryStrings.has_goods_receipt;
    const hasNotEntryCondition =
      hasPayableCondition === false && hasGoodsCondition === false;

    if (hasNotEntryCondition) return ["0"];
    if (hasPayableCondition && hasGoodsCondition) return ["1", "2"];
    if (hasPayableCondition) return ["1"];
    if (hasGoodsCondition) return ["2"];
    return undefined;
  };

  entryStatusFilterRef.current =
    getDefaultEntryStatusOptions(reduxQuerystring) || [];

  // Pure function for default entry status options
  const handleEntryStatusForceSelectOptions = () => {
    const result = getDefaultEntryStatusOptions({ ...reduxQuerystring });

    return result;
  };

  const updateAllInvoicesRef = useCallback(
    (
      _entryStatus?: number,
      _endDate?: string,
      shouldSkipVerification?: boolean
    ) => {
      const queryStringParams = { ...reduxQuerystring };
      if (!queryStringParams.modal || shouldSkipVerification) {
        endDateRef.current = queryStringParams.end_date;
        startDateRef.current = queryStringParams.start_date;
        payablesRef.current = queryStringParams.has_payable_accounts;
        goodsEntryRef.current = queryStringParams.has_goods_receipt;
        pageRef.current = queryStringParams.page;
        itemsPerPageRef.current = queryStringParams.items_per_page;
        entryStatusRef.current = queryStringParams.launch_status as
          | TInvoiceEntryStatus
          | undefined;

        // Cancel previous request
        if (fetchInvoicesCancelTokenRef.current) {
          fetchInvoicesCancelTokenRef.current.cancel(
            "Operation canceled due to new request."
          );
        }
        // Create new token for this request
        fetchInvoicesCancelTokenRef.current = axios.CancelToken.source();

        dispatch(
          fetchInvoices({
            cancelToken: (
              fetchInvoicesCancelTokenRef.current as CancelTokenSource
            ).token,
          })
        )
          .unwrap()
          .then((response) => {
            allInvoicesRef.current = response?.results;
          })
          .catch((e) => {
            if (axios.isCancel(e)) {
              // Request was canceled, do nothing
            } else {
              console.log(e);
            }
          });
      }
    },
    [window.location.search, reduxQuerystring]
  );

  const handleFilesChange = () => {
    if (selectedOrganization) {
      const globalErrors: string[] = [];

      const handleImport = (file: File, type: "danfe" | "xml") => {
        const formData = new FormData();
        formData.append(type, file);
        formData.append("file_name", file.name);

        dispatch(
          importInvoiceFiles({
            formData,
            type,
            cancelToken: (cancelTokenRef.current as CancelTokenSource).token,
          })
        )
          .unwrap()
          .then(() => {
            if (
              globalErrors.length === 0 &&
              filesInputRef.current &&
              filesInputRef.current.files
            ) {
              dispatch(
                setToastState({
                  variant: "success",
                  shouldShow: true,
                  message: {
                    title: "Sucesso",
                    description:
                      filesInputRef.current.files.length > 1
                        ? "Documentos importados"
                        : "Documento importado",
                  },
                })
              );

              dispatch(
                fetchInvoices({
                  cancelToken: (
                    fetchInvoicesCancelTokenRef.current as CancelTokenSource
                  ).token,
                })
              );
            }
          })
          .catch((e) => {
            const errorMessage = backendErrorMessageHandler(e);

            console.log("error: ", errorMessage, ", e: ", e);

            if (typeof errorMessage === "string") {
              globalErrors.push(errorMessage);
            }

            dispatch(
              setToastState({
                variant: "error",
                shouldShow: true,
                message: {
                  title: "Erro",
                  description: globalErrors.join("\n"),
                },
              })
            );
          });
      };

      if (filesInputRef.current && filesInputRef.current.files) {
        const xmlFiles: File[] = [];
        const pdfFiles: File[] = [];

        Array.from(filesInputRef.current.files).forEach((file) => {
          if (file.type.includes("xml")) {
            xmlFiles.push(file);
          } else if (file.type.includes("pdf")) {
            pdfFiles.push(file);
          }
        });

        Promise.all(
          xmlFiles.map((xml) => {
            handleImport(xml, "xml");
          })
        ).then(() => {
          Promise.all(
            pdfFiles.map((pdf) => {
              handleImport(pdf, "danfe");
            })
          ).then(() => {
            setTimeout(() => {
              debouncedUpdateAllInvoicesRef();
            }, 1000);
          });
        });
      }
    }
  };

  const debouncedUpdateAllInvoicesRef = useCallback(
    (
      _entryStatus?: number,
      _endDate?: string,
      shouldSkipVerification?: boolean
    ) => {
      const queryStringParams = { ...reduxQuerystring };
      if (
        (!queryStringParams.modal && !isRestoringQuerystring) ||
        shouldSkipVerification
      ) {
        if (debounceRef.current) clearTimeout(debounceRef.current);
        dispatch(setIsLoadingInvoices(true));
        debounceRef.current = setTimeout(() => {
          updateAllInvoicesRef(_entryStatus, _endDate, shouldSkipVerification);
        }, 500);
      }

      if (isRestoringQuerystring) {
        dispatch(setIsRestoringQuerystring(false));
      }
    },
    [updateAllInvoicesRef]
  );

  useEffect(() => {
    debouncedUpdateAllInvoicesRef();
  }, [debouncedUpdateAllInvoicesRef]);

  useEffect(() => {
    if (window.location.pathname === "/") {
      goTo(ROUTES.INVOICES, reduxQuerystring);
    }
  }, [window.location.pathname]);

  useEffect(() => {
    if (!shouldOpenRequestedPayableModal) {
      dispatch(getQueueNFE({ cancelToken: cancelTokenRef.current.token }));
    }

    if (invoiceState) {
      if (payableModalInvoiceRef.current) {
        payableModalInvoiceRef.current = invoiceState.results.find(
          (invoice) =>
            invoice.uuid === (payableModalInvoiceRef.current as TInvoice).uuid
        );
      }
    }
  }, [invoiceState, selectedOrganization]);

  useEffect(() => {
    if (toastActionId === "openRequestedPayableModal") {
      setShouldOpenRequestedPayableModal(true);
      setTimeout(() => {
        dispatch(setToastActionId(undefined));
      });
    }
  }, [toastActionId]);

  useEffect(() => {
    entryStatusRef.current = launchStatus;
    const querystring = {
      ...getQuerystringParams(),
      launch_status: launchStatus ?? 40,
      page: 1,
    };
    setQuerystring(querystring);

    startDateRef.current = querystring.start_date;
    endDateRef.current = querystring.end_date;
    itemsPerPageRef.current = querystring.items_per_page;
    pageRef.current = querystring.page;
    searchRef.current = querystring.invoices_search;
    payablesRef.current = querystring.has_payable_accounts;
    goodsEntryRef.current = querystring.has_goods_receipt;

    debouncedUpdateAllInvoicesRef();
  }, [launchStatus]);

  useEffect(() => {
    const querystring = getQuerystringParams();
    if (
      querystring?.launch_status !== undefined &&
      querystring.launch_status !== launchStatus
    ) {
      setLaunchStatus(querystring.launch_status as TInvoiceEntryStatus);
    }
  }, [window.location.search]);

  useEffect(() => {
    const pending = queueNFE.count - queueNFE.errorsCount;
    // Start polling if there is a queue, stop if not
    if (pending > 0 && !pollingIntervalRef.current) {
      // Immediately poll once
      if (cancelTokenRef.current) {
        dispatch(getQueueNFE({ cancelToken: cancelTokenRef.current.token }));
      }
      pollingIntervalRef.current = setInterval(() => {
        if (cancelTokenRef.current) {
          dispatch(getQueueNFE({ cancelToken: cancelTokenRef.current.token }));
        }
      }, 30000); // 30 seconds
    } else if (pending === 0 && pollingIntervalRef.current) {
      clearInterval(pollingIntervalRef.current);
      pollingIntervalRef.current = null;
    }

    // On every queueNFE update, check for transition
    const prevPending = prevQueueCorrelationRef.current;
    // If pending queue decreased, trigger invoice update
    if (prevPending !== null && pending < prevPending) {
      debouncedUpdateAllInvoicesRef(undefined, undefined, true);
    }
    // If pending queue was created and emptied rapidly (edge case: goes 0→N→0), always trigger update
    if (prevPending !== null && prevPending > 0 && pending === 0) {
      debouncedUpdateAllInvoicesRef(undefined, undefined, true);
    }
    // Update refs
    prevQueueCorrelationRef.current = pending;

    return () => {
      if (pollingIntervalRef.current) {
        clearInterval(pollingIntervalRef.current);
        pollingIntervalRef.current = null;
      }
    };
  }, [queueNFE.count, queueNFE.errorsCount]);

  return (
    <Container>
      <SummarySection>
        <div>
          <div>
            <h1>Notas recebidas</h1>
            <p>
              <b>CNPJ:&nbsp;</b>
              {selectedOrganization && selectedOrganization?.cnpj
                ? cnpjMask(selectedOrganization.cnpj)
                : ""}
            </p>
          </div>
          {/* {invoicesUpdatedAt.responseStatus !== 204 &&
            invoicesUpdatedAt.date.length > 0 && (
              <p>
                Atualizado em {format(invoicesUpdatedAt.date, "dd/MM/yyyy")} -{" "}
                {format(invoicesUpdatedAt.date, "HH:mm")}
              </p>
            )} */}
        </div>
        <div className="buttons-container">
          {/* <Button
            icon="plus"
            iconPosition="left"
            variant="outline"
            text="Importar"
            onClick={() => {
              if (filesInputRef.current) filesInputRef.current.click();
            }}
          /> */}
          <div></div>
          <Button
            icon="plus"
            iconPosition="left"
            variant="primary"
            text="Adicionar"
            onClick={() => {
              const importFileRef = document.getElementById(
                "quick-access-menu-button"
              );
              if (importFileRef)
                importFileButtonRef.current =
                  importFileRef as HTMLButtonElement;
              setShouldShowImportFileMenu((before) => !before);
            }}
          />
          <ImportFileMenu
            position={{ top: 46 + "px" }}
            shouldShowMenu={shouldShowImportFileMenu}
            onClickAway={() => {
              dispatch(setAttachedPaymentSlips([]));
              setShouldShowImportFileMenu(false);
            }}
          >
            <button
              onClick={() => {
                setShouldOpenImportFileModal(true);
                setShouldShowImportFileMenu(false);
              }}
            >
              <UilSearch />
              &nbsp;Via chave da NF-e
            </button>
            <button
              onClick={() => {
                if (filesInputRef.current) filesInputRef.current.click();
              }}
            >
              <UilUpload />
              &nbsp;Subir arquivo XML (NF-e ou NFS-e)
            </button>
          </ImportFileMenu>
          <input
            type="file"
            multiple
            ref={filesInputRef}
            accept=".pdf, .xml"
            style={{ display: "none" }}
            onChange={handleFilesChange}
          />
        </div>
      </SummarySection>
      <SearchBarSection>
        <SearchBar
          key={reduxQuerystring.invoices_search}
          onClear={() => {
            searchRef.current = undefined;
            const queryStrings = { ...reduxQuerystring };

            delete queryStrings.invoices_search;

            if (entryStatusRef.current) {
              queryStrings.launch_status = entryStatusRef.current ?? 40;
            }

            setQuerystring(queryStrings);

            dispatch(
              fetchInvoices({
                cancelToken: (
                  fetchInvoicesCancelTokenRef.current as CancelTokenSource
                ).token,
              })
            );
          }}
          $ref={(ref, setSearchString) => {
            if (reduxQuerystring.invoices_search && ref.current) {
              const search = decodeURIComponent(
                reduxQuerystring.invoices_search
              ).replace(/\+/g, " ");
              ref.current.value = search;
              setSearchString(search);
            }
          }}
          onSearch={(searchPhrase) => {
            searchRef.current = searchPhrase;

            if (selectedOrganization) {
              const queryStrings = { ...reduxQuerystring };

              if (searchRef.current.length > 0) {
                queryStrings.invoices_search = searchRef.current;
              } else {
                delete queryStrings.invoices_search;
              }

              if (entryStatusRef.current) {
                queryStrings.launch_status = entryStatusRef.current ?? 40;
              }

              if (queryStrings.page) {
                queryStrings.page = 1;
              }

              if (queryStrings.modal) {
                delete queryStrings.modal;
              }

              setQuerystring(queryStrings);

              // Cancel previous request before dispatching a new one
              if (fetchInvoicesCancelTokenRef.current) {
                fetchInvoicesCancelTokenRef.current.cancel(
                  "Operation canceled due to new request."
                );
              }
              fetchInvoicesCancelTokenRef.current = axios.CancelToken.source();

              dispatch(
                fetchInvoices({
                  cancelToken: fetchInvoicesCancelTokenRef.current.token,
                })
              );
            }
          }}
          variant="default"
          placeholder="Buscar por NF-e ou Emitente"
        />
        <SearchBarSectionSubcontainer id={searchBarContainerId}>
          <DropdownFilter
            key={
              reduxQuerystring.period +
              "" +
              reduxQuerystring.start_date +
              reduxQuerystring.end_date
            }
            buttonVariant="calendar"
            menuVariant="calendar"
            onSelect={handleCalendarOnSelect}
            onClear={handleCalendarOnClear}
            forceSelectOptionsByIndex={(() => {
              const result = handlePeriodForceSelectOptions();
              return shouldRejectFilledEntryStatus ||
                (result && typeof result[0] === "string")
                ? []
                : (result as number[]);
            })()}
            filled={(() => {
              const result = handlePeriodForceSelectOptions();

              return result === undefined
                ? result
                : typeof result[0] === "string"
                ? (result as string[])
                : [CALENDAR_CONTENT_OPTIONS[result[0]]];
            })()}
          />
          <DropdownFilter
            buttonVariant="checkCircle"
            placeholder="Lançamentos"
            content={filteredEntryStatusOptions}
            menuVariant="unlabeled"
            search={false}
            customFilter={handleEntryStatusCustomFilter}
            onAction={handleEntryStatusOnAction}
            onClear={handleEntryStatusOnClear}
            onCancel={handleEntryStatusOnCancel}
            hasBottomBar
            key={
              reduxQuerystring.has_payable_accounts +
              "" +
              reduxQuerystring.has_goods_receipt
            }
            forceSelectOptionsByIndex={(() => {
              const result = handleEntryStatusForceSelectOptions();
              return shouldRejectFilledEntryStatus
                ? undefined
                : result
                ? result.map(Number)
                : undefined;
            })()}
            filled={(() => {
              const result = handleEntryStatusForceSelectOptions();
              return result === undefined
                ? result
                : [...result.toString().replaceAll(",", "")];
            })()}
          />
        </SearchBarSectionSubcontainer>
        <div
          style={{
            marginLeft: "auto",
            display: "flex",
            justifyContent: "space-between",
            gap: "16px",
            height: "43px",
          }}
        >
          {queueNFE.count - queueNFE.errorsCount > 0 && (
            <Button
              variant="warning2025"
              icon="sync"
              iconPosition="left"
              text={`${queueNFE.count - queueNFE.errorsCount} solicitada${
                queueNFE.count - queueNFE.errorsCount > 1 ? "s" : ""
              }`}
              onClick={() => {
                dispatch(
                  getQueueNFE({
                    cancelToken: cancelTokenRef.current.token,
                  })
                );
                setShouldOpenRequestedPayableModal(true);
              }}
            />
          )}
          {queueNFE.errorsCount > 0 && (
            <Button
              variant="danger2025"
              icon="exclamationCircle"
              iconPosition="left"
              text={`${queueNFE.errorsCount} com erro${
                queueNFE.errorsCount > 1 ? "s" : ""
              }`}
              onClick={() => {
                dispatch(
                  getQueueNFE({
                    cancelToken: cancelTokenRef.current.token,
                  })
                );
                setShouldOpenRequestedPayableModal(true);
              }}
            />
          )}
        </div>
      </SearchBarSection>
      <MobileSupportContainer>
        <TabsGroup
          key={launchStatus}
          initialActiveTabIndex={
            launchStatus === undefined
              ? 0
              : launchStatus === 10
              ? 1
              : launchStatus === 20
              ? 2
              : launchStatus === 30
              ? 3
              : 0
          }
          onClickItems={[
            () => setLaunchStatus(undefined), // "Todas"
            () => setLaunchStatus(10), // "Pendentes"
            () => setLaunchStatus(20), // "Finalizadas"
            () => setLaunchStatus(30), // "Recusadas"
          ]}
        >
          <>
            <h2>Todas</h2>
            <div></div>
          </>
          <>
            <h2>Pendentes</h2>
          </>
          <>
            <h2>Finalizadas</h2>
            <div></div>
          </>
          <>
            <h2>Recusadas</h2>
            <div></div>
          </>
        </TabsGroup>
      </MobileSupportContainer>

      {invoiceState && (
        <TableGrid
          key={shouldUpdateComponent + "-invoices-tablegrid" + isLoading}
          row="doubleRow"
          columns={{
            tableHead: {
              // 22px 77px 160px 342px 356px 185px 346px 400px 400px 0px
              width: [gridTemplateColumns],
            },
            tableBody: {
              width: [gridTemplateColumns],
            },
          }}
          onAction={() => {
            //
          }}
          emptyState={{
            isEmptyState: !isLoading && invoiceState?.results.length === 0,
            title: "Nenhuma nota encontrada",
            description: "Altere os filtros e realize a busca novamente",
          }}
          secondRow={{
            params: invoiceState?.results.map((invoice, index) => ({
              data: {
                ...(secondRowFormatter(invoice) as TCellNotTagMiscellaneous),
                skeleton: isLoading
                  ? {
                      containerCss: {
                        display: "flex",
                        justifyContent: "space-between",
                        width: "calc(100vw - 155px)",
                        margin: "0 20px",
                      },
                      values: [
                        { width: "216px", height: "16px" },
                        {
                          width: "96px",
                          height: "16px",
                          style: { maxWidth: "96px", overflow: "hidden" },
                        },
                      ],
                    }
                  : undefined,
              },
              leftSideCustomNode: !isLoading && (
                <>{handleSecondRowLeftSideCustomNodeRender(invoice, index)}</>
              ),
              rightSideCustomNode: !isLoading && (
                <>{handleSecondRowRightSideCustomNodeRender(invoice, index)}</>
              ),
            })),
          }}
          customMarginTop="12px"
          selectType={{ type: "multiSelect", fullData: allInvoicesRef.current }}
          tableHead={{
            customPaddingTop: "0px",
            value: [
              { style: "noIcon", value: "Número", showSkeleton: isLoading },
              {
                style: "noIcon",
                value: "Data emissão",
                showSkeleton: isLoading,
              },
              { style: "noIcon", value: "Emitente", showSkeleton: isLoading },
              { style: "noIcon", value: "Valor", showSkeleton: isLoading },
              {
                style: "icon",
                icon: "infoCircle",
                iconPosition: "right",
                iconColor: "--color-text-labels",
                value: "Manifestação",
                showSkeleton: isLoading,
                tooltip: {
                  text: [
                    {
                      style: "default",
                      text: "É a comunicação do estado da transação",
                      shouldBreakLine: true,
                    },
                    {
                      style: "default",
                      text: "da nota com a SEFAZ, você pode alterar a ",
                      shouldBreakLine: true,
                    },
                    {
                      style: "default",
                      text: "manifestação clicando nas opções de ",
                      shouldBreakLine: true,
                    },
                    {
                      style: "default",
                      text: "cada NF",
                      shouldBreakLine: true,
                    },
                  ],
                  size: "large",
                },
              },
              { style: "noIcon", value: "Situação", showSkeleton: isLoading },
              { style: "noIcon", value: "Arquivos", showSkeleton: isLoading },
              {
                style: "noIcon",
                value: "Lançamentos",
                showSkeleton: isLoading,
              },
              { style: "noIcon", value: "Opções", showSkeleton: isLoading },
            ],
          }}
          isLoading={isLoading}
          tableBody={
            isLoading
              ? new Array(5).fill("").map(() => ({
                  elementId: "",
                  file_nfe: null,
                  file_xml: null,
                  body: [
                    {
                      style: "default",
                      value: "",
                      skeleton: { values: [{ width: "72px" }] },
                    },
                    {
                      style: "default",
                      value: "",
                      skeleton: { values: [{ width: "88px" }] },
                    },
                    {
                      style: "default",
                      value: "",
                      skeleton: { values: [{ width: "177px" }] },
                    },
                    {
                      style: "default",
                      value: "",
                      skeleton: { values: [{ width: "100px" }] },
                    },
                    {
                      style: "default",
                      value: "",
                      skeleton: { values: [{ width: "120px" }] },
                    },
                    {
                      style: "default",
                      value: "",
                      skeleton: { values: [{ width: "130px" }] },
                    },
                    {
                      style: "default",
                      value: "",
                      skeleton: {
                        containerCss: { display: "flex", gap: "4px" },
                        values: [
                          {
                            width: "40px",
                            height: "40px",
                            variant: "circle",
                          },
                          {
                            width: "40px",
                            height: "40px",
                            variant: "circle",
                          },
                        ],
                      },
                    },
                    {
                      style: "default",
                      value: "",
                      skeleton: {
                        containerCss: { display: "flex", gap: "4px" },
                        values: [
                          {
                            width: "40px",
                            height: "40px",
                            variant: "circle",
                          },
                          {
                            width: "40px",
                            height: "40px",
                            variant: "circle",
                          },
                        ],
                      },
                    },
                    {
                      style: "default",
                      value: "",
                      skeleton: { values: [{ width: "32px" }] },
                    },
                  ] as TTableBody<TCellStyleVariants>[],
                }))
              : (invoiceState?.results ?? []).map(
                  (invoice: TInvoice, index: number) => ({
                    elementId: invoice.uuid,
                    file_nfe: invoice.file_nfe,
                    file_xml: invoice.file_xml,
                    body: rowFormatter(invoice, index),
                  })
                )
          }
          footer={{
            customStyle: {
              width: `calc(100vw - 48px - ${sidebarOffset}px)`,
            },
            leftSideDescription:
              " | Total de " +
              invoiceState.count +
              (invoiceState.count > 1
                ? " registros encontrados"
                : " registro encontrado"),
            onSelectItemsPerPage(amount) {
              const querystring = { ...reduxQuerystring };

              if (querystring.page) {
                pageRef.current = querystring.page;
              }

              if (pageRef.current) querystring.page = pageRef.current;

              querystring.items_per_page = amount;

              setQuerystring(querystring);

              dispatch(
                fetchInvoices({
                  cancelToken: fetchInvoicesCancelTokenRef.current.token,
                })
              );
            },
            customPagination: invoiceState
              ? {
                  fixedBottom: {
                    isFixedAtTheBottom: true,
                    customBottomPosition: "0px",
                  },
                  currentPage: `${invoiceState?.current_page}`,
                  buttonBackward: {
                    disabled: invoiceState.current_page === 1,
                    onClick() {
                      pageRef.current = invoiceState.current_page - 1;

                      const queryStrings = { ...reduxQuerystring };

                      if (queryStrings.items_per_page) {
                        itemsPerPageRef.current = queryStrings.items_per_page;
                      }

                      if (invoiceState.current_page !== 1) {
                        if (pageRef.current)
                          queryStrings.page = pageRef.current;

                        setQuerystring(queryStrings);

                        dispatch(
                          fetchInvoices({
                            cancelToken:
                              fetchInvoicesCancelTokenRef.current.token,
                          })
                        );
                      }
                    },
                  },
                  buttonForward: {
                    disabled:
                      invoiceState.current_page === invoiceState.pages.length,
                    onClick() {
                      if (
                        invoiceState.current_page === invoiceState.pages.length
                      ) {
                        pageRef.current = invoiceState.current_page;
                      } else {
                        pageRef.current = invoiceState.current_page + 1;
                      }

                      const queryStrings = { ...reduxQuerystring };

                      if (queryStrings.items_per_page) {
                        itemsPerPageRef.current = queryStrings.items_per_page;
                      }

                      if (
                        invoiceState.current_page !== invoiceState.pages.length
                      ) {
                        if (pageRef.current)
                          queryStrings.page = pageRef.current;
                        setQuerystring(queryStrings);

                        dispatch(
                          fetchInvoices({
                            cancelToken:
                              fetchInvoicesCancelTokenRef.current.token,
                          })
                        );
                      }
                    },
                  },
                  pages: invoiceState.pages.map((page) => {
                    return {
                      value: Object.keys(page)[0],
                      onClick() {
                        let temp =
                          Object.values(page)[0].match(/.*?page=(\d+)&per_/);

                        if (temp !== null && temp[1]) {
                          pageRef.current = parseInt(temp[1]);
                        } else {
                          pageRef.current = 1;
                        }

                        const queryStrings = { ...reduxQuerystring };
                        if (queryStrings.items_per_page) {
                          itemsPerPageRef.current = queryStrings.items_per_page;
                        }

                        if (pageRef.current)
                          queryStrings.page = pageRef.current;
                        setQuerystring(queryStrings);

                        dispatch(
                          fetchInvoices({
                            cancelToken:
                              fetchInvoicesCancelTokenRef.current.token,
                          })
                        );
                      },
                    };
                  }),
                }
              : undefined,
          }}
        />
      )}

      {shouldOpenPayable && (
        <Modal
          key={shouldOpenPayable + "-payable"}
          shouldOpen={shouldOpenPayable}
          onClose={() => {
            setShouldOpenPayable(false);
          }}
          icon={{ type: "dolarSign", color: "rose" }}
          title="Lançar contas a pagar"
          main={{
            style: "textOnly",
            content: [
              {
                style: "default",
                text: "Deseja criar uma nova conta a pagar ou vincular a nota fiscal a uma conta já criada na Fintera?",
                shouldBreakLine: true,
              },
            ],
          }}
          footer={{
            style: "default",
            buttons: [
              {
                iconPosition: "left",
                icon: "link",
                variant: "outline",
                text: "Vincular",
                onClick() {
                  setShouldOpenPayable(false);
                  setShouldOpenLinkPayableModal(true);
                },
              },
              {
                iconPosition: "left",
                icon: "plus",
                variant: "primary",
                text: "Criar nova",
                onClick() {
                  setShouldOpenPayable(false);
                  setShouldOpenPayableModal(true);
                },
              },
            ],
          }}
        />
      )}
      {shouldOpenCancelPayableRequestModal && (
        <Modal
          key={shouldOpenCancelPayableRequestModal + "-cancelPayable"}
          shouldOpen={shouldOpenCancelPayableRequestModal}
          onClose={() => {
            setShouldOpenCancelPayableRequestModal(false);
          }}
          icon={{ type: "exclamationTriangle", color: "red" }}
          title="Cancelar solicitação"
          main={{
            style: "textOnly",
            content: [
              {
                style: "default",
                text: "Tem certeza que deseja cancelar a solicitação desta nota?",
                shouldBreakLine: true,
              },
            ],
          }}
          footer={{
            style: "default",
            buttons: [
              {
                icon: "noIcon",
                variant: "secondary",
                text: "Fechar",
                onClick() {
                  dispatch(
                    getQueueNFE({
                      cancelToken: cancelTokenRef.current.token,
                    })
                  );
                  setShouldOpenCancelPayableRequestModal(false);
                  setShouldOpenRequestedPayableModal(true);
                },
              },
              {
                icon: "noIcon",
                variant: "red",
                text: "Cancelar",
                onClick() {
                  setShouldOpenCancelPayableRequestModal(false);
                  setShouldOpenRequestedPayableModal(true);
                  dispatch(
                    deleteNFEQueue({
                      uuid: selectedNFEQueueItemRef.current?.uuid,
                      cancelToken: cancelTokenRef.current.token,
                    })
                  )
                    .unwrap()
                    .then(() => {
                      dispatch(
                        setToastState({
                          variant: "success",
                          shouldShow: true,
                          message: {
                            title: "Sucesso",
                            description: "A solicitação foi cancelada",
                          },
                        })
                      );
                    })
                    .catch((_e) => {
                      dispatch(
                        setToastState({
                          variant: "error",
                          shouldShow: true,
                          message: {
                            title: "Erro",
                            description:
                              "A nota já foi inserida e não pode mais ser cancelada, recarregue a página para visualizar",
                          },
                        })
                      );
                    })
                    .finally(() => {
                      dispatch(
                        getQueueNFE({
                          cancelToken: cancelTokenRef.current.token,
                        })
                      );
                    });
                },
              },
            ],
          }}
        />
      )}
      {shouldOpenPayableModal && (
        <Modal
          key={shouldOpenPayableModal + "-payableModal"}
          shouldOpen={shouldOpenPayableModal}
          icon={{ type: "dolarSign", color: "rose" }}
          title="Lançar nota como contas a pagar"
          onClose={() => {
            setShouldOpenPayableModal(false);
          }}
          main={{
            style: "form",
            content: {
              preset: "addPayable",
              invoice: payableModalInvoiceRef.current as TInvoice,
              footer: {
                buttons: [
                  {
                    icon: "noIcon",
                    text: "Cancelar",
                    variant: "secondary",
                    onClick() {
                      setShouldOpenPayableModal(false);
                    },
                  },
                  {
                    iconPosition: "left",
                    icon: "checkmark",
                    text: "Lançar conta a pagar",
                    variant: "primary",
                    onClick() {
                      setTimeout(() => {
                        if (payableModalInvoiceRef.current) {
                          dispatch(
                            fetchInvoice({
                              invoiceUuid: payableModalInvoiceRef.current?.uuid,
                              cancelToken:
                                fetchInvoicesCancelTokenRef.current.token,
                            })
                          );
                        }
                      }, 100);
                      setShouldOpenPayableModal(false);
                    },
                  },
                ],
              },
            },
          }}
        />
      )}
      {shouldOpenLinkPayableModal && (
        <Modal
          key={shouldOpenLinkPayableModal + "-linkPayableModal"}
          shouldOpen={shouldOpenLinkPayableModal}
          icon={{ type: "link", color: "rose" }}
          title="Vincular nota a conta já lançada"
          onClose={() => {
            setShouldOpenLinkPayableModal(false);
          }}
          main={{
            style: "form",
            content: {
              preset: "linkPayable",
              invoice: payableModalInvoiceRef.current as TInvoice,
              footer: {
                buttons: [
                  {
                    icon: "noIcon",
                    text: "Cancelar",
                    variant: "secondary",
                    onClick() {
                      setShouldOpenLinkPayableModal(false);
                    },
                  },
                  {
                    iconPosition: "left",
                    icon: "checkmark",
                    text: "Vincular nota como anexo",
                    variant: "primary",
                    isLoading: isLinkPayableLoading,

                    onClick(selectRow) {
                      if (selectRow.hasInstallments) {
                        selectPayableRef.current = selectRow.selectPayable;
                        setShouldOpenLinkPayableModal(false);
                        setShouldOpenInstallmentAccountModal(true);
                      } else {
                        if (payableModalInvoiceRef.current) {
                          setIsLinkPayableLoading(true);

                          dispatch(
                            linkInvoiceToPayable({
                              invoiceUuid: payableModalInvoiceRef.current.uuid,
                              payableId: selectRow.selectPayable.id,
                              cancelToken: cancelTokenRef.current.token,
                            })
                          )
                            .unwrap()
                            .then((_response) => {
                              setIsLinkPayableLoading(false);
                              dispatch(
                                fetchInvoices({
                                  cancelToken:
                                    fetchInvoicesCancelTokenRef.current.token,
                                })
                              );
                              dispatch(
                                setToastState({
                                  variant: "success",
                                  shouldShow: true,
                                  message: {
                                    title: "Sucesso",
                                    description:
                                      "Nota vinculada à contas a pagar",
                                  },
                                })
                              );
                              setShouldOpenLinkPayableModal(false);
                            })
                            .catch((e) => {
                              const errorMessage =
                                backendErrorMessageHandler(e);
                              console.log("error: ", e);

                              setTimeout(() => {
                                if (payableModalInvoiceRef.current) {
                                  dispatch(
                                    fetchInvoice({
                                      invoiceUuid:
                                        payableModalInvoiceRef.current?.uuid,
                                      cancelToken:
                                        fetchInvoicesCancelTokenRef.current
                                          .token,
                                    })
                                  );
                                }
                              }, 100);

                              setIsLinkPayableLoading(false);
                              dispatch(
                                setToastState({
                                  variant: "error",
                                  shouldShow: true,
                                  message: {
                                    title: "Erro ao vincular nota",
                                    description:
                                      typeof errorMessage === "string"
                                        ? errorMessage
                                        : "Ocorreu um erro ao vincular a nota à Contas a Pagar, tente novamente",
                                  },
                                })
                              );
                              setShouldOpenLinkPayableModal(false);
                            });
                        }
                      }
                    },
                  },
                ],
              },
            },
          }}
        />
      )}
      {shouldOpenInstallmentAccountModal && (
        <Modal
          shouldOpen={shouldOpenInstallmentAccountModal}
          onClose={() => {
            setShouldOpenInstallmentAccountModal(false);
          }}
          icon={{ type: "link", color: "rose" }}
          title="Vincular à conta parcelada"
          main={{
            style: "form",
            content: {
              preset: "installmentAccount",
              invoice: payableModalInvoiceRef.current as TInvoice,
              footer: {
                buttons: [
                  {
                    variant: "secondary",
                    icon: "noIcon",
                    text: "Cancelar",
                    onClick() {
                      setShouldOpenInstallmentAccountModal(false);
                    },
                  },
                  {
                    variant: "primary",
                    iconPosition: "left",
                    icon: "checkmark",
                    text: "Vincular nota como anexo",
                    isLoading: isLinkPayableLoading,
                    onClick() {
                      if (
                        payableModalInvoiceRef.current &&
                        selectPayableRef.current
                      ) {
                        setIsLinkPayableLoading(true);

                        dispatch(
                          linkInvoiceToPayable({
                            invoiceUuid: payableModalInvoiceRef.current.uuid,
                            payableId: `${selectPayableRef.current.id}`,
                            cancelToken: cancelTokenRef.current.token,
                          })
                        )
                          .unwrap()
                          .then((_response) => {
                            setIsLinkPayableLoading(false);
                            dispatch(
                              fetchInvoices({
                                cancelToken:
                                  fetchInvoicesCancelTokenRef.current.token,
                              })
                            );
                            dispatch(
                              setToastState({
                                variant: "success",
                                shouldShow: true,
                                message: {
                                  title: "Sucesso",
                                  description:
                                    "Nota vinculada à contas a pagar",
                                },
                              })
                            );
                            setShouldOpenInstallmentAccountModal(false);
                          })
                          .catch((e) => {
                            const errorMessage = backendErrorMessageHandler(e);
                            console.log("error: ", e);
                            setTimeout(() => {
                              if (payableModalInvoiceRef.current) {
                                dispatch(
                                  fetchInvoice({
                                    invoiceUuid:
                                      payableModalInvoiceRef.current?.uuid,
                                    cancelToken:
                                      fetchInvoicesCancelTokenRef.current.token,
                                  })
                                );
                              }
                            }, 100);
                            setIsLinkPayableLoading(false);
                            dispatch(
                              setToastState({
                                variant: "error",
                                shouldShow: true,
                                message: {
                                  title: "Erro ao vincular nota",
                                  description:
                                    typeof errorMessage === "string"
                                      ? errorMessage
                                      : "Ocorreu um erro ao vincular a nota à Contas a Pagar, tente novamente",
                                },
                              })
                            );
                            setShouldOpenInstallmentAccountModal(false);
                          });
                      }
                    },
                  },
                ],
              },
            },
          }}
        />
      )}
      {shouldOpenGoodsModal && (
        <Modal
          key={shouldOpenGoodsModal + "-goodsModal"}
          shouldOpen={shouldOpenGoodsModal}
          onClose={() => {
            setShouldOpenGoodsModal(false);
          }}
          icon={{ type: "import", color: "rose" }}
          title="Criar entrada de mercadorias"
          main={{
            style: "form",
            content: {
              preset: "goods",
              invoice: payableModalInvoiceRef.current as TInvoice,
              footer: {
                buttons: [
                  {
                    variant: "secondary",
                    icon: "noIcon",
                    text: "Cancelar",
                    onClick() {
                      setShouldOpenGoodsModal(false);
                    },
                  },
                  {
                    variant: "primary",
                    iconPosition: "left",
                    icon: "checkmark",
                    text: "Criar entrada de mercadorias",
                    onClick(isExpressMode: boolean) {
                      setShouldOpenGoodsModal(false);

                      if (isExpressMode) {
                        setShouldOpenGoodsAutomatedModal(true);
                        setTimeout(() => {
                          if (payableModalInvoiceRef.current) {
                            dispatch(
                              fetchInvoice({
                                invoiceUuid:
                                  payableModalInvoiceRef.current?.uuid,
                                cancelToken:
                                  fetchInvoicesCancelTokenRef.current.token,
                              })
                            );
                          }
                        }, 100);
                      } else {
                        dispatch(
                          fetchInvoices({
                            cancelToken:
                              fetchInvoicesCancelTokenRef.current.token,
                          })
                        );
                      }
                    },
                  },
                ],
              },
            },
          }}
        />
      )}
      {shouldOpenGoodsAutomatedModal && (
        <Modal
          key={shouldOpenGoodsAutomatedModal + "-goodsAutomatedModal"}
          shouldOpen={shouldOpenGoodsAutomatedModal}
          onClose={() => {
            setShouldOpenGoodsAutomatedModal(false);
            setTimeout(() => {
              if (payableModalInvoiceRef.current) {
                dispatch(
                  fetchInvoice({
                    invoiceUuid: payableModalInvoiceRef.current?.uuid,
                    cancelToken: fetchInvoicesCancelTokenRef.current.token,
                  })
                );
              }
            }, 100);
          }}
          icon={{ type: "import", color: "rose" }}
          title={
            payableModalInvoiceRef.current?.nexaas_state === 60
              ? "Entrada de mercadorias"
              : "Criar entrada de mercadorias"
          }
          main={{
            style: "form",
            content: {
              preset: "goodsAutomated",
              invoice: payableModalInvoiceRef.current as TInvoice,
              onCheckStockNeeded: (response) => {
                if (
                  response &&
                  payableModalInvoiceRef.current?.nexaas_state === 60
                ) {
                  goodsStockCheckDataRef.current = response;
                  setShouldOpenGoodsAutomatedModal(false);
                  setShouldOpenGoodsCompletedModal(true);
                } else if (response) {
                  goodsStockCheckDataRef.current = response;
                  setShouldOpenGoodsAutomatedModal(false);
                  setShouldOpenGoodsStockCheckModal(true);
                }
              },
              footer: {
                buttons: [
                  {
                    variant: "white",
                    icon: "noIcon",
                    text: "",
                    onClick(response) {
                      if (response.shouldUpdate) {
                        setTimeout(() => {
                          if (payableModalInvoiceRef.current) {
                            dispatch(
                              fetchInvoice({
                                invoiceUuid:
                                  payableModalInvoiceRef.current?.uuid,
                                cancelToken:
                                  fetchInvoicesCancelTokenRef.current.token,
                              })
                            );
                          }
                        }, 100);
                      }

                      if (response.data) {
                        goodsStockCheckDataRef.current = response.data;
                        setShouldOpenGoodsAutomatedModal(false);
                        setShouldOpenGoodsStockCheckModal(true);
                      }
                    },
                  },
                ],
              },
            },
          }}
        />
      )}
      {goodsStockCheckDataRef.current &&
        payableModalInvoiceRef.current &&
        shouldOpenGoodsStockCheckModal && (
          <Modal
            key={shouldOpenGoodsStockCheckModal + "-goodsStockCheckModal"}
            shouldOpen={shouldOpenGoodsStockCheckModal}
            onClose={() => {
              setShouldOpenGoodsStockCheckModal(false);
            }}
            icon={{ type: "import", color: "rose" }}
            title={
              <div style={{ display: "flex", alignItems: "center" }}>
                <h1>Conferência de quantidades</h1>
                <a
                  style={{
                    cursor: "pointer",
                    color: "var(--color-text-link)",
                    fontSize: "14px",
                    display: "flex",
                    alignItems: "center",
                    gap: "4px",
                    position: "absolute",
                    right: "50px",
                    top: "27px",
                  }}
                  href={updatedInvoice?.goods_receipt_url ?? ""}
                  target="_blank"
                  rel="noreferrer"
                >
                  <UilExternalLinkAlt
                    style={{ width: "14px", height: "14px", marginLeft: "2px" }}
                  />
                  Acessar no OMS
                </a>
              </div>
            }
            main={{
              style: "form",
              content: {
                preset: "goodsStockCheck",
                data: {
                  success: goodsStockCheckDataRef.current.success ?? [],
                  error: goodsStockCheckDataRef.current.error ?? [],
                  invoiceId: payableModalInvoiceRef.current.uuid,
                },
                footer: {
                  buttons: [
                    {
                      variant: "white",
                      icon: "sync",
                      iconPosition: "left",
                      text: "Atualizar lista",
                      style: {
                        padding: "8px",
                        color: "var(--color-main-blue)",
                        fontFamily: "var(--font-paragraph-default)",
                      },
                      onClick() {
                        setTimeout(() => {
                          if (payableModalInvoiceRef.current) {
                            dispatch(
                              fetchInvoice({
                                invoiceUuid:
                                  payableModalInvoiceRef.current?.uuid,
                                cancelToken:
                                  fetchInvoicesCancelTokenRef.current.token,
                              })
                            );
                          }
                        }, 100);
                      },
                    },
                    {
                      variant: "secondary",
                      icon: "noIcon",
                      text: "Fechar",
                      onClick() {
                        setShouldOpenGoodsStockCheckModal(false);

                        setTimeout(() => {
                          if (payableModalInvoiceRef.current) {
                            dispatch(
                              fetchInvoice({
                                invoiceUuid:
                                  payableModalInvoiceRef.current?.uuid,
                                cancelToken:
                                  fetchInvoicesCancelTokenRef.current.token,
                              })
                            );
                          }
                        }, 100);
                      },
                    },
                    {
                      variant: "primary",
                      iconPosition: "left",
                      icon: "checkmark",
                      text: "Confirmar entrada",
                      onClick() {
                        if (
                          selectedOrganization &&
                          payableModalInvoiceRef.current
                        ) {
                          dispatch(
                            createExpressGoodsStockEntry({
                              invoiceUuid: payableModalInvoiceRef.current.uuid,
                              cancelToken: cancelTokenRef.current.token,
                            })
                          )
                            .unwrap()
                            .then(() => {
                              setShouldOpenGoodsStockCheckModal(false);
                              dispatch(
                                setToastState({
                                  variant: "information",
                                  shouldShow: true,
                                  message: {
                                    title: "Lançamento em andamento",
                                    description:
                                      "O estoque está sendo lançado em segundo plano e pode levar alguns minutos",
                                  },
                                })
                              );
                              dispatch(
                                fetchInvoices({
                                  cancelToken:
                                    fetchInvoicesCancelTokenRef.current.token,
                                })
                              )
                                .unwrap()
                                .then((response) => {
                                  const updatedInvoice = response.results.find(
                                    (inv) =>
                                      inv.uuid ===
                                      payableModalInvoiceRef.current?.uuid
                                  );

                                  if (updatedInvoice?.nexaas_state === 60) {
                                    dispatch(
                                      setToastState({
                                        variant: "success",
                                        shouldShow: true,
                                        message: {
                                          title: "Sucesso",
                                          description:
                                            "Entrada finalizada com sucesso",
                                        },
                                      })
                                    );
                                    setShouldOpenGoodsCompletedModal(true);
                                  }
                                });
                            })
                            .catch((e) => {
                              const errorMessage =
                                backendErrorMessageHandler(e);

                              setTimeout(() => {
                                if (payableModalInvoiceRef.current) {
                                  dispatch(
                                    fetchInvoice({
                                      invoiceUuid:
                                        payableModalInvoiceRef.current?.uuid,
                                      cancelToken:
                                        fetchInvoicesCancelTokenRef.current
                                          .token,
                                    })
                                  );
                                }
                              }, 100);

                              dispatch(
                                setToastState({
                                  variant: "error",
                                  shouldShow: true,
                                  message: {
                                    title: "Erro ao lançar estoque",
                                    description:
                                      typeof errorMessage === "string"
                                        ? errorMessage
                                        : "Ocorreu um erro ao lançar o estoque, tente novamente",
                                  },
                                })
                              );
                            });
                        }
                      },
                    },
                  ],
                },
              },
            }}
          />
        )}
      {goodsStockCheckDataRef.current &&
        payableModalInvoiceRef.current &&
        shouldOpenGoodsCompletedModal && (
          <Modal
            key={shouldOpenGoodsCompletedModal + "-goodsCompletedModal"}
            shouldOpen={shouldOpenGoodsCompletedModal}
            onClose={() => {
              setShouldOpenGoodsCompletedModal(false);
            }}
            icon={{ type: "import", color: "rose" }}
            title={
              <div style={{ display: "flex", alignItems: "center" }}>
                <>
                  <h1 style={{ marginRight: "8px" }}>Entrada de mercadorias</h1>
                  <Tag
                    color="green"
                    icon="noIcon"
                    size="small"
                    text="Finalizada"
                  />
                </>
                <a
                  style={{
                    cursor: "pointer",
                    color: "var(--color-text-link)",
                    fontSize: "14px",
                    display: "flex",
                    alignItems: "center",
                    gap: "4px",
                    position: "absolute",
                    right: "50px",
                    top: "27px",
                  }}
                  href={updatedInvoice?.goods_receipt_url ?? ""}
                  target="_blank"
                  rel="noreferrer"
                >
                  <UilExternalLinkAlt
                    style={{ width: "14px", height: "14px", marginLeft: "2px" }}
                  />
                  Acessar no OMS
                </a>
              </div>
            }
            main={{
              style: "form",
              content: {
                preset: "goodsCompleted",
                data: {
                  success: goodsStockCheckDataRef.current.success ?? [],
                  error: goodsStockCheckDataRef.current.error ?? [],
                  invoiceId: payableModalInvoiceRef.current.uuid,
                },
                footer: {
                  buttons: [
                    {
                      variant: "secondary",
                      icon: "noIcon",
                      text: "Fechar",
                      onClick() {
                        setShouldOpenGoodsCompletedModal(false);
                      },
                    },
                  ],
                },
              },
            }}
          />
        )}
      {shouldOpenLinkPaymentSlipModal && (
        <Modal
          shouldOpen={shouldOpenLinkPaymentSlipModal}
          onClose={() => {
            if (clearSelectedPaymentSlipsRef.current) {
              clearSelectedPaymentSlipsRef.current();
            }
            setInvoiceToAttachLinks(null);
            setShouldOpenLinkPaymentSlipModal(false);
          }}
          icon={{ type: "link", color: "rose" }}
          title="Selecionar boletos"
          main={{
            style: "form",
            content: {
              preset: "linkPaymentSlip",
              footer: {
                buttons: [
                  {
                    variant: "secondary",
                    icon: "noIcon",
                    text: "Cancelar",
                    onClick() {
                      if (clearSelectedPaymentSlipsRef.current) {
                        clearSelectedPaymentSlipsRef.current();
                      }
                      setInvoiceToAttachLinks(null);
                      setShouldOpenLinkPaymentSlipModal(false);
                    },
                  },
                  {
                    variant: "primary",
                    iconPosition: "left",
                    icon: "checkmark",
                    text: "Confirmar selecionado(s)",
                    isLoading: isLinkPayableLoading,
                    onClick(data: {
                      selectedPaymentSlips: TPaymentSlip[];
                      clearSelectedPaymentSlips: () => void;
                    }) {
                      clearSelectedPaymentSlipsRef.current =
                        data.clearSelectedPaymentSlips;

                      data.selectedPaymentSlips.forEach(
                        (paymentSlip, index) => {
                          if (invoiceToAttachLinks) {
                            setIsLinkPayableLoading(true);

                            dispatch(
                              attachPaymentSlipToInvoice({
                                invoiceUuid: invoiceToAttachLinks.uuid,
                                paymentSlipUuid: paymentSlip.uuid,
                                cancelToken: cancelTokenRef.current.token,
                              })
                            )
                              .unwrap()
                              .then(() => {
                                if (
                                  index ===
                                  data.selectedPaymentSlips.length - 1
                                ) {
                                  setIsLinkPayableLoading(false);
                                  dispatch(
                                    fetchInvoices({
                                      cancelToken:
                                        fetchInvoicesCancelTokenRef.current
                                          .token,
                                    })
                                  );
                                  dispatch(
                                    setToastState({
                                      variant: "success",
                                      shouldShow: true,
                                      message: {
                                        title: "Sucesso",
                                        description:
                                          data.selectedPaymentSlips.length > 1
                                            ? "Notas vinculadas à conta a pagar"
                                            : "Nota vinculada à contas a pagar",
                                      },
                                    })
                                  );
                                  setInvoiceToAttachLinks(null);
                                  data.clearSelectedPaymentSlips();
                                  setShouldOpenLinkPaymentSlipModal(false);
                                }
                              })
                              .catch((e) => {
                                const errorMessage =
                                  backendErrorMessageHandler(e);
                                console.log("error: ", e);
                                setTimeout(() => {
                                  if (payableModalInvoiceRef.current) {
                                    dispatch(
                                      fetchInvoice({
                                        invoiceUuid:
                                          payableModalInvoiceRef.current?.uuid,
                                        cancelToken:
                                          fetchInvoicesCancelTokenRef.current
                                            .token,
                                      })
                                    );
                                  }
                                }, 100);
                                setIsLinkPayableLoading(false);
                                dispatch(
                                  setToastState({
                                    variant: "error",
                                    shouldShow: true,
                                    message: {
                                      title: "Erro ao vincular nota",
                                      description:
                                        typeof errorMessage === "string"
                                          ? errorMessage
                                          : "Ocorreu um erro ao vincular a nota à Contas a Pagar, tente novamente",
                                    },
                                  })
                                );
                                setInvoiceToAttachLinks(null);
                                data.clearSelectedPaymentSlips();
                                setShouldOpenLinkPaymentSlipModal(false);
                              });
                          }
                        }
                      );
                    },
                  },
                ],
              },
            },
          }}
        />
      )}
      {paymentSlipToBreakLink !== undefined && (
        <Modal
          key={paymentSlipToBreakLink?.target.uuid}
          title="Remover vínculo"
          icon={{ type: "breakLink", color: "red" }}
          main={{
            style: "textOnly",
            content: [
              {
                text: "Tem certeza que deseja remover o vínculo com este boleto?",
                style: "default",
                shouldBreakLine: false,
              },
            ],
          }}
          footer={{
            style: "default",
            buttons: [
              {
                variant: "secondary",
                icon: "noIcon",
                text: "Cancelar",
                onClick() {
                  setPaymentSlipToBreakLink(undefined);
                },
              },
              {
                variant: "red",
                iconPosition: "left",
                icon: "checkmark",
                text: "Sim, remover",
                onClick() {
                  if (paymentSlipToBreakLink) {
                    dispatch(
                      detachPaymentSlipFromInvoice({
                        invoiceUuid: paymentSlipToBreakLink.origin.uuid,
                        paymentSlipUuid: paymentSlipToBreakLink.target.uuid,
                        cancelToken: cancelTokenRef.current.token,
                      })
                    )
                      .unwrap()
                      .then(() => {
                        setPaymentSlipToBreakLink(undefined);
                        dispatch(
                          setToastState({
                            variant: "success",
                            shouldShow: true,
                            message: {
                              title: "Sucesso",
                              description: "Vínculo removido",
                            },
                          })
                        );
                        dispatch(
                          fetchInvoices({
                            cancelToken:
                              fetchInvoicesCancelTokenRef.current.token,
                          })
                        );
                      })
                      .catch((e) => {
                        const errorMessage = backendErrorMessageHandler(e);

                        setTimeout(() => {
                          if (payableModalInvoiceRef.current) {
                            dispatch(
                              fetchInvoice({
                                invoiceUuid:
                                  payableModalInvoiceRef.current?.uuid,
                                cancelToken:
                                  fetchInvoicesCancelTokenRef.current.token,
                              })
                            );
                          }
                        }, 100);

                        setPaymentSlipToBreakLink(undefined);
                        dispatch(
                          setToastState({
                            variant: "error",
                            shouldShow: true,
                            message: {
                              title: "Erro",
                              description:
                                typeof errorMessage === "string"
                                  ? errorMessage
                                  : "Não foi possível remover o vínculo, tente novamente",
                            },
                          })
                        );
                      });
                  }
                },
              },
            ],
          }}
          shouldOpen={paymentSlipToBreakLink !== undefined}
          onClose={() => {
            setPaymentSlipToBreakLink(undefined);
          }}
        />
      )}
      {paymentSlipToRename !== undefined && (
        <Modal
          key={paymentSlipToRename?.uuid}
          title="Renomear arquivo"
          icon={{ type: "edit", color: "rose" }}
          main={{
            style: "form",
            content: {
              preset: "renameDocument",
              data: paymentSlipToRename,
              footer: {
                buttons: [
                  {
                    variant: "secondary",
                    icon: "noIcon",
                    text: "Cancelar",
                    onClick() {
                      setPaymentSlipToRename(undefined);
                    },
                  },
                  {
                    variant: "primary",
                    iconPosition: "left",
                    icon: "checkmark",
                    text: "Salvar",
                    onClick(label: string) {
                      if (paymentSlipToRename) {
                        dispatch(
                          renamePaymentSlipLabel({
                            paymentSlipUuid: paymentSlipToRename.uuid,
                            label,
                            cancelToken: cancelTokenRef.current.token,
                          })
                        )
                          .unwrap()
                          .then(() => {
                            setPaymentSlipToRename(undefined);
                            dispatch(
                              setToastState({
                                variant: "success",
                                shouldShow: true,
                                message: {
                                  title: "Sucesso",
                                  description: "Boleto renomeado",
                                },
                              })
                            );
                            setTimeout(() => {
                              if (payableModalInvoiceRef.current) {
                                dispatch(
                                  fetchInvoice({
                                    invoiceUuid:
                                      payableModalInvoiceRef.current?.uuid,
                                    cancelToken:
                                      fetchInvoicesCancelTokenRef.current.token,
                                  })
                                );
                              }
                            }, 100);
                          })
                          .catch((e) => {
                            const errorMessage = backendErrorMessageHandler(e);
                            setPaymentSlipToRename(undefined);
                            setTimeout(() => {
                              if (payableModalInvoiceRef.current) {
                                dispatch(
                                  fetchInvoice({
                                    invoiceUuid:
                                      payableModalInvoiceRef.current?.uuid,
                                    cancelToken:
                                      fetchInvoicesCancelTokenRef.current.token,
                                  })
                                );
                              }
                            }, 100);
                            dispatch(
                              setToastState({
                                variant: "error",
                                shouldShow: true,
                                message: {
                                  title: "Erro",
                                  description:
                                    typeof errorMessage === "string"
                                      ? errorMessage
                                      : "Não foi possível renomear o boleto, tente novamente",
                                },
                              })
                            );
                          });
                      }
                    },
                  },
                ],
              },
            },
          }}
          shouldOpen={paymentSlipToRename !== undefined}
          onClose={() => {
            setPaymentSlipToRename(undefined);
          }}
        />
      )}

      {shouldOpenRequestedPayableModal && (
        <Modal
          key={shouldOpenRequestedPayableModal + "-payable"}
          shouldOpen={shouldOpenRequestedPayableModal}
          onClose={() => {
            setShouldOpenRequestedPayableModal(false);
          }}
          icon={{ type: "sync", color: "rose" }}
          title="Notas solicitadas"
          description="Essas são as notas NF-e que foram solicitadas para a SEFAZ mas que ainda não foram sincronizadas"
          main={{
            style: "table",
            content: {
              customHeight: "360px",
              columns: {
                // 412px 131px 183px 64px
                tableHead: {
                  width: "0px 16px 412px 131px 183px 33px".split(" "),
                },
                tableBody: {
                  width: "0px 16px 412px 131px 183px 33px".split(" "),
                },
              },
              row: "doubleRow",
              secondRow: {
                params: (queueNFE.results ?? []).map((item) => ({
                  data: {
                    style: "miscellaneous",
                    values: [
                      { style: "default", text: "", shouldBreakLine: false },
                    ],
                  },
                  customLinkContainer: {
                    hasDoubleRow: !isLoadingQueueNFE && item.has_error,
                    node: item.has_error && (
                      <div style={{ fontSize: "12px" }}>
                        <b style={{ color: "var(--color-aux-danger-700)" }}>
                          Motivo do erro:
                        </b>
                        &nbsp;{item.reason}
                      </div>
                    ),
                    trCSSProperties: {
                      background: "var(--color-aux-danger-100)",
                      display: "flex",
                      borderBottom: "1px solid var(--color-aux-danger-700)",
                    },
                  },
                })),
              },
              selectType: { type: "noSelect" },

              emptyState: {
                isEmptyState: !isLoadingQueueNFE && queueNFE.count === 0,
                title: "Nenhuma nota encontrada",
                description: "Não há nenhuma nota solicitada pendente",
              },
              tableHead: {
                customTopPosition: "0px",
                value: [
                  {
                    style: "noIcon",
                    showSkeleton: isLoadingQueueNFE,
                    value: "Chave da nota",
                  },
                  {
                    style: "noIcon",
                    showSkeleton: isLoadingQueueNFE,
                    value: "Status",
                  },
                  {
                    style: "noIcon",
                    showSkeleton: isLoadingQueueNFE,
                    value: "Data da solicitação",
                  },
                ],
              },
              isLoading: isLoadingQueueNFE,
              tableBody: isLoadingQueueNFE
                ? new Array(5).fill("").map(() => ({
                    elementId: "",
                    file_nfe: null,
                    file_xml: null,
                    body: [
                      {
                        style: "default",
                        value: "",
                        skeleton: { values: [{ width: "320px" }] },
                      },
                      {
                        style: "default",
                        value: "",
                        skeleton: { values: [{ width: "80px" }] },
                      },
                      {
                        style: "default",
                        value: "",
                        skeleton: { values: [{ width: "120px" }] },
                      },
                      {
                        style: "default",
                        value: "",
                        skeleton: { values: [{ width: "32px" }] },
                      },
                    ] as TTableBody<TCellStyleVariants>[],
                  }))
                : (queueNFE.results ?? [])
                    .map((item) => ({
                      accessKey: item.access_key,
                      status: item.has_error ? "Erro" : "Solicitada",
                      requestDate: format(
                        new Date(item.created_at),
                        "dd/MM/yyyy - HH:mm"
                      ),
                      ...item,
                    }))
                    .map((item) => ({
                      elementId: item.accessKey,
                      file_nfe: null,
                      file_xml: null,
                      body: [
                        { style: "default", value: item.accessKey },
                        {
                          style: item.status === "Erro" ? "red" : "orange",
                          icon: "noIcon",
                          value: item.status,
                        },
                        { style: "default", value: item.requestDate },
                        {
                          style: "button",
                          icon: "times-red",
                          tooltip: {
                            text: [
                              {
                                style: "default",
                                text: "Cancelar",
                                shouldBreakLine: false,
                              },
                            ],
                          },
                          onClick() {
                            selectedNFEQueueItemRef.current = item;
                            setShouldOpenRequestedPayableModal(false);
                            setShouldOpenCancelPayableRequestModal(true);
                          },
                        },
                      ] as TTableBody<TCellStyleVariants>[],
                    })),
            },
          }}
          footer={{
            style: "default",
            buttons: [
              {
                iconPosition: "left",
                icon: "sync",
                variant: "link",
                text: "Atualizar lista",
                onClick() {
                  if (cancelTokenRef.current) {
                    dispatch(
                      getQueueNFE({
                        cancelToken: cancelTokenRef.current.token,
                      })
                    );
                  }
                },
              },
              {
                variant: "secondary",
                icon: "noIcon",
                text: "Fechar",
                onClick() {
                  setShouldOpenRequestedPayableModal(false);
                },
              },
            ],
          }}
        />
      )}
      {shouldOpenImportFileModal && (
        <Modal
          key={shouldOpenImportFileModal + "-payable"}
          shouldOpen={shouldOpenImportFileModal}
          onClose={() => {
            setShouldOpenImportFileModal(false);
          }}
          icon={{ type: "search", color: "rose" }}
          title="Solicitar NF-e via chave de acesso"
          main={{
            style: "form",
            content: {
              preset: "accessKeyImport",
            },
          }}
          footer={{
            style: "default",
            buttons: [
              {
                variant: "secondary",
                icon: "noIcon",
                text: "Cancelar",
                onClick() {
                  setShouldOpenImportFileModal(false);
                },
              },
              {
                iconPosition: "left",
                icon: "checkmark",
                variant: "primary",
                text: "Solicitar",
                disabled: !accessKeys.some((key) => key.length > 0),
                onClick() {
                  if (cancelTokenRef.current) {
                    dispatch(
                      onSubmitAccessKeys({
                        cancelToken: cancelTokenRef.current.token,
                      })
                    )
                      .unwrap()
                      .then(() => {
                        setShouldOpenImportFileModal(false);
                        dispatch(
                          getQueueNFE({
                            cancelToken: cancelTokenRef.current.token,
                            mock: 2,
                          })
                        );

                        setTimeout(() => {
                          dispatch(
                            getQueueNFE({
                              cancelToken: cancelTokenRef.current.token,
                              mock: 2,
                            })
                          );
                        }, 600);

                        setTimeout(() => {
                          dispatch(
                            getQueueNFE({
                              cancelToken: cancelTokenRef.current.token,
                              mock: 1,
                            })
                          );
                        }, 1200);

                        setTimeout(() => {
                          dispatch(
                            getQueueNFE({
                              cancelToken: cancelTokenRef.current.token,
                              mock: 1,
                            })
                          );
                        }, 1800);

                        setTimeout(() => {
                          dispatch(
                            getQueueNFE({
                              cancelToken: cancelTokenRef.current.token,
                              mock: 1,
                            })
                          );
                        }, 2100);

                        dispatch(
                          setToastState({
                            variant: "success",
                            message: {
                              title: "Solicitação realizada",
                              description:
                                "As notas foram solicitadas à SEFAZ, esse processo pode levar alguns minutos.",
                              linkText: {
                                text: "Acesse aqui a lista de notas solicitadas",
                                actionId: "openRequestedPayableModal",
                              },
                            },
                            shouldShow: true,
                          })
                        );
                      })
                      .catch((e) => {
                        if (!Array.isArray(e)) {
                          const errorMessage = backendErrorMessageHandler(e[0]);

                          dispatch(
                            setToastState({
                              variant: "error",
                              shouldShow: true,
                              message: {
                                title: "Erro",
                                description: errorMessage ?? "",
                              },
                            })
                          );
                        }
                      });
                  }
                },
              },
            ],
          }}
        />
      )}
    </Container>
  );
}

export default Home;
